import type { SVGProps } from 'react'

const SvgChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.5"
      y="17.5"
      width="17"
      height="17"
      rx="8.5"
      transform="rotate(-90 0.5 17.5)"
      fill="white"
    />
    <rect
      x="0.5"
      y="17.5"
      width="17"
      height="17"
      rx="8.5"
      transform="rotate(-90 0.5 17.5)"
      stroke="#5E5E5E"
    />
    <path
      d="M7.17561 6.57682L9.5344 9.01899L7.17561 11.4612C7.07601 11.5816 7.02397 11.7365 7.02988 11.8949C7.03579 12.0533 7.09922 12.2035 7.20749 12.3156C7.31576 12.4277 7.46089 12.4934 7.6139 12.4995C7.7669 12.5056 7.9165 12.4518 8.0328 12.3487L10.8232 9.45959C10.9364 9.34166 11 9.18213 11 9.01584C11 8.84956 10.9364 8.69003 10.8232 8.5721L8.0328 5.68303C7.91889 5.5658 7.76481 5.5 7.6042 5.5C7.44359 5.5 7.28951 5.5658 7.17561 5.68303C7.06302 5.80258 7 5.96295 7 6.12992C7 6.2969 7.06302 6.45727 7.17561 6.57682Z"
      fill="#5E5E5E"
    />
  </svg>
)

export default SvgChevronRight
